import { LoadingContainer, ModelViewer } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInternalLoanBalancesGet } from 'core/types'

const LoanBalances = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: balances,
    isLoading,
    error,
  } = useInternalLoanBalancesGet({
    companyId,
    personId,
    loanId,
  })

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <Page variant='full'>
        <ModelViewer json={balances} />
      </Page>
    </LoadingContainer>
  )
}

export default LoanBalances
